import styled from 'styled-components'

import { Text as _Text } from '~/components/address'
import _AffirmLogo from '~/components/affirm-logo'
import { device, color, font } from '~/styles/utils'

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.color.text.default};
  background-color: ${({ theme }) => theme.color.background.default};
  padding: 20px;
  box-shadow: 5px 6px 30px 0 rgba(0, 0, 0, 0.15);
  margin: 0;
  @media ${device('notMobile')} {
    margin: 38px 0 0 0;
    padding: 35px 50px;
  }
`

export const PaymentTitle = styled.h2`
  ${font('bold')};
  font-size: 24px;
  margin: 0;
  border-bottom: 1px solid ${color('lightGrey')};
  padding: 0 0 18px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const PaymentSubtitle = styled.h3`
  margin: 16px 7px 10px 0;
  font-size: 16px;
  line-height: 20px;
  ${font('bold')};

  color: ${({ theme }) => theme.color.text.default};
  text-transform: uppercase;
`

export const TextV1 = styled(_Text)`
  font-size: 16px;
  color: ${({ theme }) => theme.color.text.default};
`

export const LogoWrapper = styled.div`
  width: 65px;
  padding: 0 0 0 10px;
`

export const AffirmLogo = styled(_AffirmLogo)`
  width: 100%;
`

export const NoPaymentRequiredMessage = styled.span`
  size: 18px;
  line-height: 22px;
  color: ${({ theme }) => theme.color.text.default};
`
